import React, { useContext, useState } from "react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";
import ScDicomCopyToClipboardButton from "../Tools/ScDicomCopyToClipboardButton";
import SaveAsScDicomButton from "../Tools/SaveAsScDicomButton";
import SaveAsPRButton from "../Tools/SaveAsPRButton";
import MarkAsKOButton from "../Tools/MarkAsKOButton";
import { USERTYPES } from "../../../../constants/Constants";
import userContext from "../../../../context/users/UserContext";
//added for quality flag
import useImageQuality from "../../../../hooks/useImageQuality";
import QualityIcon from "../../../../components/QualityIcon/QualityIcon";


const SCDICOMDetails = ({ viewportData, viewportIndex, copyToClipboard, handleUploadScDicom, currentImage }) => {
  const { roles } = useContext(userContext);
  //added for quality flag
  const contextValues = useContext(studyviewerContext) || {};
  const { studyResponseData, priorStudyResponseData, studyParentId } = contextValues;

  const activeData = priorStudyResponseData?.studyDtoList?.length > 0
    ? priorStudyResponseData
    : studyResponseData;

  const { imageErrorsMap } = useImageQuality(activeData);

  const imageId = viewportData?.stack?.images?.[currentImage]?.id;
  const currentImageErrors = imageErrorsMap[String(imageId)] || [];

  // In the patient (priors) viewer a viewport may show a PRIOR study rather than
  // the current/parent study. Capturing SC, and adding KO / PR, must only be
  // allowed on the parent study — prior studies are read-only references. The
  // viewport's own study id (viewportData.study) vs studyParentId is the
  // established "is this the parent study?" check (see Viewport.jsx). When study
  // is unset (normal single-study viewer) this is NOT a prior, so buttons show.
  const isPriorStudy =
    viewportData?.study != null &&
    studyParentId != null &&
    String(viewportData.study) !== String(studyParentId);


  return (
    <>
      <div className="viewport-overlay-sc-dicom">
        {viewportData && (
          <>
            {/* Copy to clipboard only reads the viewport, so every role gets it. */}
            <span style={{ lineHeight: "15px" }}>
              <ScDicomCopyToClipboardButton viewportIndex={viewportIndex} copyToClipboard={copyToClipboard} />
            </span>

            {(roles?.includes(USERTYPES.RADIOLOGIST) || roles?.includes(USERTYPES.SUPERVISOR) || roles?.includes(USERTYPES.FIRMADMIN)) && (
              <>
                {/* Capture SC, Save PR and Mark KO are only allowed on the parent
                    study — never on prior studies in the patient viewer. */}
                {!isPriorStudy && (
                  <>
                    <span style={{ lineHeight: "15px" }}>
                      <SaveAsScDicomButton viewportIndex={viewportIndex} handleUploadScDicom={handleUploadScDicom} />
                    </span>

                    <span style={{ lineHeight: "15px" }}>
                      <SaveAsPRButton viewportIndex={viewportIndex} />
                    </span>

                    <span style={{ lineHeight: "15px" }}>
                      <MarkAsKOButton viewportIndex={viewportIndex} />
                    </span>
                  </>
                )}

            </>
            )}
            {/* added for quality flag */}
            <span style={{ lineHeight: "15px" }}>
              {currentImageErrors.length > 0 && (
                <QualityIcon errors={currentImageErrors.map(e => e.class ? `${e.class} - ${e.message}` : e.message)} style={{ marginTop: '5px', zoom: 1.3 }} />

              )}
            </span>


          </>
        )}
      </div>
    </>
  );
};

export default SCDICOMDetails;
